import { node } from 'prop-types';
import { useFeatureContext } from './featureContext';
import { Button, Heading, Stack } from '@chaser/components';

const FeatureGateCTA = ({ text, buttonText = 'View plans', style, className }) => {
  const ctx = useFeatureContext();

  return (
    <Stack alignItems="center" className={className} style={style}>
      <Heading as="h2" fontSize="heading.3" fontWeight="bold">
        {text}
      </Heading>
      <div>
        <Button
          data-testid="view-plans-btn"
          data-trackingid="view-plans-btn"
          onClick={ctx.onUpgrade}
        >
          {buttonText}
        </Button>
      </div>
    </Stack>
  );
};

FeatureGateCTA.propTypes = {
  text: node.isRequired,
};

export default FeatureGateCTA;
